<template>
  <a-modal v-model="ordersSortible" title="订单排序" @ok="addordersSort()">
    <a-row>
      <a-col
        :span="12"
        style="margin: 5px;overflow: hidden;overflow-y: scroll;border: 1px solid #ccc;width: 350px;padding: 20px;height:400px"
      >
        <a-row v-for="(item, i) in columns" :key="item.dataIndex" style="padding-top: 20px">
          <a-col :span="10">
            <a-radio-group v-model="value" @change="onChangeradio">
              <a-radio :style="radioStyle" :value="item.dataIndex">
                {{ item.title }}
              </a-radio>
            </a-radio-group>
            <!--<a-checkbox @change="onChangeright(i,$event)" style="height:-->
            <!--30px">{{item-->
            <!--.title}}</a-checkbox>-->
          </a-col>
          <br />
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between">
      <a-col :span="1" style="display: flex;justify-content: space-between;"> </a-col>
      <a-col :span="6" style="width: 90%">
        <a-button type="primary" @click="up">
          上移
        </a-button>
        <a-button type="primary" style="margin-left: 18px;" @click="down">
          下移
        </a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { getOrderHeader, getUserOrderSort, getaddUserOrderSort } from '@/api/order/editorder'
export default {
  name: 'ordersSortModel',
  data() {
    return {
      value: '',
      ordersSortible: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'id'
        },
        {
          title: '操作栏',

          dataIndex: 'action'
        },
        {
          title: '状态栏',
          dataIndex: 'orderLevel'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '安装类别',
          dataIndex: 'installType'
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          align: 'center'
        },

        {
          title: '订单状态',
          dataIndex: 'orderStatus'
        },
        {
          title: '订单子状态',
          dataIndex: 'orderSubStatus'
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal'
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName'
        },
        {
          title: '联系方式',
          dataIndex: 'clientPhone'
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddress'
        },
        {
          title: '订单来源',
          dataIndex: 'sourceEnterpriseName',
          align: 'center'
        },
        {
          title: 'CTEI码',
          dataIndex: 'ctei',
          align: 'center'
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName'
        },
        {
          title: '师傅联系方式',
          dataIndex: 'masterPhone'
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterLeading'
        },
        {
          title: '师傅结算状态',
          dataIndex: 'masterSettleStatus',
          align: 'center'
        },
        {
          title: '订单协助人',
          dataIndex: 'helperName'
        },
        {
          title: '付款方式',
          dataIndex: 'payType'
        },
        {
          title: '预约上门时间',
          dataIndex: 'reserveTimePart'
        },
        {
          title: '销单时间',
          dataIndex: 'saleTime'
        },
        {
          title: '核销时间',
          dataIndex: 'checkTime'
        },
        {
          title: '订单完成时间',
          dataIndex: 'orderFinishTime'
        },
        {
          title: '建单时间',
          dataIndex: 'createTime'
        },
        {
          title: '暂不结算时间',
          dataIndex: 'temporarilySettleTime'
        },
        {
          title: '超时时长',
          dataIndex: 'timeOutDuration'
        },
        {
          title: '建单人',
          dataIndex: 'createBy'
        },
        {
          title: '介入时间',
          dataIndex: 'intervenDuration'
        }
      ]
    }
  },
  methods: {
    addordersSort() {
      getaddUserOrderSort(this.columns).then(res => {
        if (res.code === 0) {
          this.ordersSortible = false
          this.$emit('ok')
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    showorderSort() {
      this.ordersSortible = true
      getUserOrderSort().then(res => {
        console.log(res)
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.columns = res.data
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangeradio(e) {
      // this.
      // console.log('radio checked', e.target.value);
    },
    up() {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].dataIndex == this.value) {
          if (i != -1 && i != 0) {
            ;[this.columns[i - 1], this.columns[i]] = [this.columns[i], this.columns[i - 1]]
          }
          let keys = []
          this.columns.forEach(key => keys.push(key))
          this.columns = keys
        }
      }
    },
    down() {
      for (let i = this.columns.length - 1; i >= 0; i--) {
        if (this.columns[i].dataIndex == this.value) {
          if (i != -1 && i != this.columns.length - 1) {
            ;[this.columns[i + 1], this.columns[i]] = [this.columns[i], this.columns[i + 1]]
          }
          let keys = []
          this.columns.forEach(key => keys.push(key))
          this.columns = keys
        }
        // break
      }
    }
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>
